module.exports = __webpack_public_path__ + "img/icdeposit.fb7e4174.png";